import http from "./constants/http";
import resources from "./constants/resources";

// 견적 바구니 담기
export const PackagingInsertSet = async (body) => {
  const res = await http(resources.PACKAGINGBASKET).post(body);

  if (res.status === 200) {
    return res.data;
  } else {
    return res;
  }
};

// 견적 바구니 불러오기
export const PackagingListSet = async (body) => {
  const res = await http(resources.PACKAGINGBASKET).post(body);

  if (res.status === 200) {
    return res.data;
  } else {
    return res;
  }
};

// 바구니 아이템 삭제
export const PackagingDeleteSet = async (body) => {
  const res = await http(resources.PACKAGINGBASKET).post(body);

  if (res.status === 200) {
    return res.data;
  } else {
    return res;
  }
};
